// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"LocaleSwitchHeader_iconWrapper__eaICt","pulse":"LocaleSwitchHeader_pulse__cHVDz"};